//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Close } from '@mui/icons-material';
//  -- Components ---------------------
import { lighten } from 'polished';
import React from 'react';
import styled from 'styled-components';
//  -- Constants ----------------------
import { Modal } from '@mui/material';
import Loading from 'components/Loading';
import { Img } from 'react-image';
import COLOR from 'utils/constants/color';

const ORDER_BY = [
    { key: "due_date", value: "Due Date" },
    { key: "start_date", value: "Start Date" },
]

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const AssignmentContainer = styled.div`
    border: 1px solid #F4F5F7;
    height: 100%;
    min-height: 160px;
    padding 8px 4px;
`;

const Container = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const Button = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.green200};
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;

    &:hover {
        color: ${COLOR.green}
    }
`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const ContainerDay = styled.div`
    border-bottom: 4px solid #03989e82;
    border-right: 2px solid #03989e82;
    border-left: 2px solid #03989e82;
    flex: 1;
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 124px;

    &:last-child {
        margin-right: 0px;
    }
`;

const ControlRow = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const AllHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

     @media (max-width: 570px) {
       display:block;
       text-align: center;
     }
`;

const CustomRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

const Date = styled.span`
    color: #fff;
    display: block;
    font-size: 11px;
    line-height: 10px;
    margin-bottom: 6px;
`;

const DayOfWeek = styled.span`
    background-color: #03989e82;
    border-radius: 2px;
    color: ${COLOR.black};
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    padding: 12px 12px;
`;

const Header = styled.span`
    color: ${COLOR.black600};
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
`;

const HeaderBold = styled(Header)`
    color: ${COLOR.black100};
`;

const Item = styled.div`
    align-items: center;
    background-color: ${p => p.deactivated ? COLOR.redishpink : p.disabled ? COLOR.green900 : (p.past ? lighten(0.4, 'red') : COLOR.white)};
    border: 1px dashed ${p => (p.deactivated || p.disabled || p.past) ? COLOR.white : COLOR.black700};
    border-radius: 2px;
    color: ${p => (p.deactivated || p.disabled || p.past) ? COLOR.white : COLOR.black200};
    cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
    display: flex;
    flex-direction: row;
    font-size: 13px;
    line-height: 15px;
    margin-bottom: 4px;
    position: relative;
    text-transform: capitalize;
    transition: all 450ms ease;
    width: 100%;

    @media (min-width: 1000px) {
        &:hover {
            background-color: ${p => !p.past && '#f9f9f9'};
            color:${COLOR.green};
            box-shadow: ${p => !p.past && '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'};
        }
    }
`

const Wrapper = styled.div`
    width: 100%;
`;
const CalendarDay = styled.div`
    background-color:${p => p.isToday ? COLOR.orange100 : "#5f4c82"};
    border:3px solid #c5a1cf;
    border-radius: 15px;
    padding: 10px;
    position: relative;
    flex: 1;
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 124px;
    min-height: 180px;
    &:last-child {
        margin-right: 0px;
    }
    @media screen and (max-width: 992px) {
        min-width: 150px;
    }
    @media screen and (min-width: 360px) and (max-width: 420px) {
        min-width: 160px;
    }
    @media screen and (min-width: 522px) and (max-width: 580px) {
        min-width: 165px;
    }
    @media screen and (min-width: 680px) and (max-width: 690px) {
        min-width: 165px;
    }
    @media screen and (min-width: 690px) and (max-width: 730px) {
        min-width: 165px;
    }
    @media screen and (min-width: 846px) and (max-width: 930px) {
        min-width: 165px;
    }
    @media screen and (min-width: 992px) and (max-width: 1260px) {
        min-width: 165px;
    }
`;
const HeaderRow = styled.div`
    flex-direction: row;
    display: flex;
`
// const CalendarIcon = styled.div`
//     flex: 1;
//     background-image: url(${Calendarimg});
//     background-repeat: no-repeat;
//     background-size: 200% 200%;
//     background-size: 40px 40px;
//     height: 25px;
//     width: 30px;
//     background-position: center;
// `
const GradCalendarSec = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;

`
const Birtdimg = styled.img`
    height: 180px;
    width: 220px;
    position: absolute;
    top: -80px;
    left: -110px;
    z-index: -1;
    user-select: none;
`
const DayTxt = styled.div`
    flex: 6;
    color: white;
    font-size: 20px;
    `;
const ItemTab = styled.button`
    height:100%;
    width:80%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    cursor: pointer;
`;


const ImageModal = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: 90vh;
    margin-top:20px;
`;
const ModalDescription = styled.div`
    background: #E7E8EA;
    display: flex;
    padding: 5px;
    flex-direction: column;
`;
const CloseBtn = styled.div`
    background-color: rgb(204, 80, 71);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 2;
    position:absolute;
    top:-45px;
    right:-13px;
`;
const StyledImg = styled(Img)`
  width: ${({ imgType }) => (imgType ? "70vw" : "100%")};
  height: 100%;
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;

  @media (min-width: 1367px) {
    width: ${({ imgType }) => (imgType ? "34vw" : "100%")};
  }

  @media (max-width: 600px) {
    max-height: 70vh;
  }
`;
const ModelDescRow = styled.div`
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
    position:absolute;
    background:#E7E8EA;
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    height:35px;
    border-bottom:.5px solid lightgray;
    margin-top:-35px;
`;
//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  -- Description
//  Calendar of events for quick view
//
//  -- Props
//  ...
//
const AssignmentImgModal = ({
    setModalOpen,
    modalOpen,
    page_src,
    className="",
    title,
    description = ""
}) => {
    const closeViewinfo = () => {
        setModalOpen(false)
    }
    return (
        <div>
            <Modal
                open={modalOpen}
                onClose={closeViewinfo}
                style={{ height: '100%', width: '100%' }}
                className='assignment-image-modal modal-image-container-review'
            >
                <ImageModal className='relative'>
                    <div className="mdlcont">
                        <CloseBtn onClick={closeViewinfo}>
                            <Close className="closeIcns" />
                        </CloseBtn>
                        <ModelDescRow>
                            {description}
                        </ModelDescRow>
                        <StyledImg src={page_src} loader={<Loading />} />
                        {title ? (
                        <ImageStoryTitle className='customImgTitle'>{title || ""}</ImageStoryTitle> 
                    ): null}
                    </div>
                </ImageModal>
            </Modal>
        </div>
    );
};

export default AssignmentImgModal;

const ImageStoryTitle = styled.div`
    position: absolute;
    top: 54.5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: ${(props) => props?.fontSize ? props?.fontSize : "20px"};
    z-index: 1;
`;